<template>
  <v-container fluid fill-height class="ma-0 pa-0" style="background-color: #95C72B">
    <img src="../../public/assets/logo.png" height="10%" contain style="position: absolute; left: 0; top: 0;margin: 30px;"></img>
    <v-layout class="align-center justify-center">
      <v-flex class="lg6">
        <v-card-title style="font-size: 32px; font-weight: bold; color: white" class="justify-center ma-0 pa-0">
          Welcome
        </v-card-title>
        <v-text-field
          solo
          background-color="#edf3ea"
          hide-details
          class="textfield_style my-5"
          append-icon="email"
          @keyup.enter="performLogin()"
          name="login"
          type="text"
          v-model="tf_email"
          placeholder="Email"
        />
        <v-text-field
          solo
          background-color="#edf3ea"
          hide-details
          v-model="tf_password"
          class="textfield_style mt-3"
          @keyup.enter="performLogin()"
          append-icon="lock"
          name="login"
          type="password"
          placeholder="Password"
        />
        <transition duration="10000" v-if="login_error">
        <v-slide-y-transition>
          <div class="pa-2 red login-error-statement">
            {{this.error_string}}
          </div>
        </v-slide-y-transition>
      </transition>
        <v-card-text class="forgotPassword ma-0 pa-0 my-4" @click="editProfile()">
          Create a new Account
        </v-card-text>
<!--        <v-card-text class="forgotPassword ma-0 pa-0 my-4" @click="$router.push({name: 'AdminLogin'})">-->
<!--          Admin Login-->
<!--        </v-card-text>-->
        <v-btn
          v-if="notLoading"
          class="signInButton align-center justify-center"
          color="white"
          style="color: #95C72B; border: 1px solid #8de867; font-size: 16px; font-weight: bold"
          large
          @click="performLogin()">
          SIGN IN
        </v-btn>
        <v-progress-circular
          v-if="Loading"
          indeterminate
          color="white"
          size="20"
        >
        </v-progress-circular>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "Login",
  data: () =>{
    return {
      tf_email:'',
      tf_password:'',
      login_error: false,
      error_string: "",
      notLoading: true,
      Loading: false,
    }
  },
  mounted() {
    this.$socket.$subscribe('userdata', payload => {
      //console.log(payload)
    });
    /*console.log("event registered")
    this.$socket.$unsubscribe('userdata');
    this.$socket.$subscribe('userdata', payload => {
      alert("payload received")
      console.log(payload)
    });*/
  },
  methods: {
    editProfile() {
      this.$router.push({name: 'SignUp'});
    },

    performLogin() {
      this.notLoading = false;
      this.Loading = true;
      /*this.$socket.client.emit('updateUserData', "working");
      return*/
      this.login_error = false
      if(this.tf_email == "" && this.tf_password == "")
      {
        this.login_error = true;
        this.error_string = "Email and Password field cannot be empty."
        this.notLoading = true;
        this.Loading = false;
      }
      else if(this.tf_email == "")
      {
        this.login_error = true;
        this.error_string = "Email cannot be empty."
        this.notLoading = true;
        this.Loading = false;
      }
      else if(this.tf_password == "")
      {
        this.login_error = true;
        this.error_string = "Password field cannot be empty."
        this.notLoading = true;
        this.Loading = false;
      }
      else{
        var loginURL = this.$hostname+"/api/user/login"
        var loginData = new FormData();
        loginData.append("email",this.tf_email)
        loginData.append("password",this.tf_password)
        if (this.tf_email.match(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ) == null) {
          this.login_error = true;
          this.error_string = "Please enter a valid email address";
        }
        else{
          axios
            .post(loginURL, loginData)
            .then((response) => {
              if (response.data.state == "Success") {
                localStorage.setItem("email", this.tf_email)
                localStorage.setItem("session_id", response.data.data.session)

                this.$router.push({name: "Dashboard"})
              }
              else if (response.data.state == "Error"){
                this.login_error = true;
                this.error_string = response.data.message;
                this.notLoading = true;
                this.Loading = false;
                //console.log(response.data.message)
              }
              //console.log(response)
            })
            .catch((error) => {
              console.log(error);
              this.notLoading = true;
              this.Loading = false;
            })
            .finally(() => {
              this.notLoading = true;
              this.Loading = false;
            });
        }
      }
    }
  }
}

</script>

<style scoped>

.forgotPassword{
  text-decoration: underline;
  font-size: 16px ;
  color: white;
}

.signInButton{
  border-radius: 20px;
}
.v-text-field--solo.textfield_style, .v-input__slot.textfield_style{
  border: 1px solid #8de867 !important;
  background-color: #8de867 !important;
  border-radius: 5px !important;
}

.login-error-statement{
  border-radius: 4px;
  font-size: 14px;
  font-family: Helvetica;
}
</style>



// WEBPACK FOOTER //
// src/UserViews/Login.vue